<div [formGroup]="form" *ngIf="form">
  <ion-item>
    <bones-form-label [item]="item"></bones-form-label>
    <ion-input type="date" #dateInput [readonly]="item.readonly" (ionChange)="onChange()"></ion-input>
    <ion-input type="time" #timeInput [readonly]="item.readonly" (ionChange)="onChange()" *ngIf="item.date.timeEntry"></ion-input>
  </ion-item>
</div>
